import "./App.css";
import Home from "./pages/Home";
import Career from "./pages/Carrer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Fragment } from "react";

import "./fonts/NeueMontreal-Bold.otf";
import "./fonts/NeueMontreal-Medium.otf";
import "./fonts/NeueMontreal-Regular.otf";
import "./fonts/NeueMontreal-Light.otf";
import "./fonts/Sk-Modernist-Bold.otf";
import "./fonts/Sk-Modernist-Regular.otf";
import "./fonts/Sk-Modernist-Mono.otf";
export default function App() {
  return (
    <Fragment>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/career" element={<Career />} />
        </Routes>
      </Router>
    </Fragment>
  );
}
